import {
    methodSchema,
    requestConnectionPropertyModifySchema,
    responseHandlerSchema,
} from "components/Forms/ConnectionCreatorEditorFormSections/formSchema";
import { ResponsePropertySourceType } from "types/enums";
import { z } from "zod";


// ResponseConnectionPropertyData
export const responseConnectionPropertySchema = z.object({
    id: z.string().optional(),
    response_handler_id: z.string().nullable().optional(),
    accessor: z.string().nullable(),
    system_name: z.string(),
    description: z.string().nullable(),
    source: z.nativeEnum(ResponsePropertySourceType),
    value: z.string().nullable(),
    created_at: z.string().nullable().optional(),
    updated_at: z.string().nullable().optional(),
    requestConnectionPropertyModify: z.array(requestConnectionPropertyModifySchema).optional(),
    responseHandler: responseHandlerSchema.optional(),
});

// IncomingPostbackData
export const incomingPostbackSchema = z.object({
    id: z.string(),
    all_offer: z.union([z.number(), z.boolean()]),
    type: z.string(),
    format: z.string(),
    http_method: z.string(),
    name: z.string(),
    description: z.string(),
    active: z.union([z.number(), z.boolean()]),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable(),
    offers: z.array(z.unknown()).optional(),
    responseConnectionProperties: z.array(responseConnectionPropertySchema).optional(),
});

// Combined Schema for Methods and Postbacks
export const schema = z.object({
    // postback: incomingPostbackSchema,
    methods: z.array(methodSchema).optional(),
    first_sequence_step_id: z.string().nullable(),
    // responseConnectionPropertiesQuery: z.array(responseConnectionPropertySchema),
    // responseConnectionPropertiesBody: z.array(responseConnectionPropertySchema),
    // responseConnectionPropertiesHttpCode: z.array(responseConnectionPropertySchema),
    responseConnectionProperties: z.array(responseConnectionPropertySchema),
});

export type FormData = z.infer<typeof schema>;
